import React from 'react';
import { 
  Globe, 
  BookOpen, 
  Smartphone, 
  ShoppingCart, 
  Headphones, 
  Play,
  Mail, 
  ArrowLeft,
  ExternalLink,
  ClipboardCheck,
  GraduationCap,
  Monitor
} from 'lucide-react';
import { Link } from 'react-router-dom';

const BookLinks = () => {
  const sections = [
    {
      title: 'Official Websites',
      links: [
        {
          label: 'ThirdCultureLeadership.com',
          url: 'https://thirdcultureleadership.com',
          icon: Globe,
          color: 'bg-navy'
        },
        {
          label: 'ThirdCultureLeadership.co.uk',
          url: 'https://thirdcultureleadership.co.uk',
          icon: Globe,
          color: 'bg-slate-700'
        }
      ]
    },
    {
      title: 'Read Online',
      links: [
        {
          label: 'Web Reader (Read Now)',
          url: '/books/cultural-fluency-without-compromise/read',
          icon: Monitor,
          color: 'bg-gold',
          isInternal: true,
          highlight: true
        }
      ]
    },
    {
      title: 'Buy the Book',
      links: [
        {
          label: "Author's Bookstore (Books.by)",
          url: 'https://books.by/promond-publishing/cultural-fluency-without-com',
          icon: BookOpen,
          color: 'bg-navy'
        },
        {
          label: 'Lulu (Paperback)',
          url: 'https://www.lulu.com/shop/promise-monday/cultural-fluency-without-compromise/paperback/product-yv99428.html?page=1&pageSize=4',
          icon: BookOpen,
          color: 'bg-orange-600'
        },
        {
          label: 'IngramSpark Bookstore',
          url: 'https://shop.ingramspark.com/b/084?params=1CCZrkXiXMS5PYiAqIsDohyLwSpxWqvREQ2Yk1GgXXz',
          icon: ShoppingCart,
          color: 'bg-blue-600'
        },
        {
          label: 'Apple Books (eBook)',
          url: 'https://books.apple.com/gb/book/cultural-fluency-without-compromise/id6755616279',
          icon: Smartphone,
          color: 'bg-slate-800'
        }
      ]
    },
    {
      title: 'Amazon Stores',
      links: [
        {
          label: 'Amazon USA',
          url: 'https://www.amazon.com/dp/1918265003',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇺🇸'
        },
        {
          label: 'Amazon UK',
          url: 'https://www.amazon.co.uk/dp/1918265003',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇬🇧'
        },
        {
          label: 'Amazon Canada',
          url: 'https://www.amazon.ca/dp/1918265003',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇨🇦'
        },
        {
          label: 'Amazon Australia',
          url: 'https://www.amazon.com.au/dp/1918265003',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇦🇺'
        },
        {
          label: 'Amazon Europe',
          url: 'https://amzn.eu/d/5nxbl5g',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇪🇺'
        },
        {
          label: 'Amazon India',
          url: 'https://www.amazon.in/dp/B0FSYH736X',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇮🇳'
        },
        {
          label: 'Amazon Japan',
          url: 'https://www.amazon.co.jp/dp/B0FSYH736X',
          icon: ShoppingCart,
          color: 'bg-amber-600',
          flag: '🇯🇵'
        }
      ]
    },
    {
      title: 'Listen to Podcast',
      links: [
        {
          label: 'RSS.com Podcast',
          url: 'https://rss.com/podcasts/solvestackhq/2470986',
          icon: Headphones,
          color: 'bg-orange-500'
        },
        {
          label: 'Spotify Episode',
          url: 'https://open.spotify.com/episode/5HA636qgTGJR7fEca7UWAv?si=ekbn8kALQL-GPkhLDO6ZEA&t=106',
          icon: Play,
          color: 'bg-green-600'
        },
        {
          label: 'Apple Podcasts',
          url: 'https://podcasts.apple.com/gb/podcast/the-solve-stack-book-solution-including-3-books-1/id1870407221?i=1000745824702',
          icon: Headphones,
          color: 'bg-purple-600'
        },
        {
          label: 'YouTube Episode',
          url: 'https://youtu.be/h0Pu082KSII?si=dvOuAffmqJuCJv8q',
          icon: Play,
          color: 'bg-red-600'
        }
      ]
    },
    {
      title: 'Resources',
      links: [
        {
          label: 'CFQ™ Assessment',
          url: '/cfq-assessment',
          icon: ClipboardCheck,
          color: 'bg-gold',
          isInternal: true
        },
        {
          label: 'Self-Paced Course',
          url: '/courses',
          icon: GraduationCap,
          color: 'bg-navy',
          isInternal: true
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-soft-grey to-white">
      {/* Main Container */}
      <div className="max-w-[720px] mx-auto px-6 py-10 md:py-16">
        
        {/* Back to Books - Top */}
        <Link 
          to="/books"
          className="inline-flex items-center gap-2 text-slate-500 hover:text-navy mb-8 transition-colors text-sm"
        >
          <ArrowLeft size={16} />
          Back to Books
        </Link>

        {/* Header */}
        <div className="text-center mb-10">
          {/* Book Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-[#f5f5f5] p-1 rounded-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_thirdculture-lead/artifacts/pokw9n65_Cultural%20fluency%20without%20Compromise%20App%20Icon.png"
                alt="Cultural Fluency Without Compromise"
                className="w-32 h-32 md:w-40 md:h-40 object-contain rounded-xl"
                style={{ mixBlendMode: 'multiply' }}
              />
            </div>
          </div>
          
          {/* Title */}
          <h1 className="font-serif text-2xl md:text-3xl font-bold text-navy mb-2">
            Cultural Fluency Without Compromise
          </h1>
          
          {/* Subtitle */}
          <p className="text-slate-600 italic mb-3">
            Thriving Across Cultures with Presence and Integrity
          </p>
          
          {/* Gold Accent Line */}
          <div className="w-16 h-0.5 bg-gold mx-auto mb-3"></div>
          
          {/* Author */}
          <p className="text-slate-500 text-sm">
            by <span className="font-semibold text-navy">Promise Monday</span>
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {sections.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              {/* Section Title */}
              <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-1">
                {section.title}
              </h2>
              
              {/* Links */}
              <div className="space-y-2">
                {section.links.map((link, linkIndex) => {
                  const Icon = link.icon;
                  
                  if (link.isInternal) {
                    return (
                      <Link
                        key={linkIndex}
                        to={link.url}
                        className={`flex items-center gap-4 w-full p-4 rounded-xl transition-all duration-200 group shadow-sm border ${
                          link.highlight 
                            ? 'bg-gold/10 hover:bg-gold/20 border-gold/30 hover:border-gold/50' 
                            : 'bg-white hover:bg-soft-grey border-slate-100'
                        }`}
                      >
                        <div className={`w-10 h-10 ${link.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform`}>
                          <Icon size={20} className={link.color === 'bg-gold' ? 'text-navy' : 'text-white'} />
                        </div>
                        <span className={`font-medium flex-1 group-hover:text-gold transition-colors ${link.highlight ? 'text-navy font-semibold' : 'text-navy'}`}>
                          {link.label}
                        </span>
                        <ArrowLeft size={16} className="text-slate-400 group-hover:text-gold transition-colors rotate-180" />
                      </Link>
                    );
                  }
                  
                  return (
                    <a
                      key={linkIndex}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-4 w-full p-4 bg-white hover:bg-soft-grey rounded-xl transition-all duration-200 group shadow-sm border border-slate-100"
                    >
                      <div className={`w-10 h-10 ${link.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform`}>
                        {link.flag ? (
                          <span className="text-lg">{link.flag}</span>
                        ) : (
                          <Icon size={20} className="text-white" />
                        )}
                      </div>
                      <span className="font-medium text-navy flex-1 group-hover:text-gold transition-colors">
                        {link.label}
                      </span>
                      <ExternalLink size={16} className="text-slate-400 group-hover:text-gold transition-colors" />
                    </a>
                  );
                })}
              </div>
            </div>
          ))}

          {/* Contact Section */}
          <div>
            <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-1">
              Contact
            </h2>
            
            <div className="bg-navy rounded-xl p-6">
              <a
                href="mailto:culturalfluency.book@thirdcultureleadership.co.uk"
                className="flex items-center gap-4 w-full p-4 bg-white/10 hover:bg-white/20 rounded-xl transition-colors mb-3"
              >
                <div className="w-10 h-10 bg-gold rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail size={20} className="text-navy" />
                </div>
                <span className="font-medium text-white flex-1">
                  Email Author
                </span>
                <ExternalLink size={16} className="text-white/60" />
              </a>
              
              <p className="text-sm text-white/80 text-center mb-1">
                culturalfluency.book@thirdcultureleadership.co.uk
              </p>
              
              <p className="text-xs text-white/60 text-center">
                For speaking, training, partnerships, or questions about the book.
              </p>
            </div>
          </div>
        </div>

        {/* Back to Books - Bottom */}
        <div className="mt-10 text-center">
          <Link 
            to="/books"
            className="inline-flex items-center gap-2 text-navy hover:text-gold transition-colors text-sm font-medium"
          >
            <ArrowLeft size={16} />
            Back to Books
          </Link>
        </div>

        {/* Footer */}
        <footer className="mt-12 pt-6 border-t border-slate-200">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-sm text-slate-500">
            <span>© Third Culture Leadership</span>
            <span className="hidden sm:inline">•</span>
            <Link to="/privacy" className="hover:text-navy transition-colors">
              Privacy Policy
            </Link>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default BookLinks;
